
export default function Checkbox(props)
{
    return <input type="checkbox" className="form-check-input m-0" {...props} />
}
